import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';

export const slide = () => {
  return (
    <Slide notes="Introduction of Jonathan and EVA" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <WebContent
          animation={{
            type: 'fade',
            delay: 0,
            duration: 800,
          }}
        >
          <h2 className="title">Introductie</h2>
        </WebContent>

        <div className="grid grid-cols-2 gap-12 mt-8">
          <WebContent
            animation={{
              type: 'fade',
              delay: 1000,
              duration: 800,
            }}
          >
            <div>
              <h3 className="text-3xl font-semibold mb-4">Jonathan IJzerman</h3>
              <div className="space-y-2">
                <p>• RobotCandy</p>
                <p>• AI Enthusiast</p>
                <p>• Software Developer</p>
                <p>• Creative Mind</p>
              </div>
            </div>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <div>
              <h3 className="text-3xl font-semibold mb-4">EVA</h3>
              <div className="space-y-2">
                <p>• Enterprise Virtual Assistant</p>
                <p>• AI-powered co-presenter</p>
                <p>• Real-time AI collaboration</p>
                <p>• Amazing personality</p>
              </div>
            </div>
          </WebContent>
        </div>
      </div>
    </Slide>
  );
};
